import { render, staticRenderFns } from "./performanceForm.vue?vue&type=template&id=1bac063c"
import script from "./performanceForm.vue?vue&type=script&lang=js"
export * from "./performanceForm.vue?vue&type=script&lang=js"
import style0 from "./performanceForm.vue?vue&type=style&index=0&id=1bac063c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports